import imageDe from '../images/de/uploader-caresensBt-4.png';
import imageEn from '../images/en/uploader-caresensBt-4.png';
import imageEs from '../images/es/uploader-caresensBt-4.png';
import imageFi from '../images/fi/uploader-caresensBt-4.png';
import imageFr from '../images/fr/uploader-caresensBt-4.png';
import imageIt from '../images/it/uploader-caresensBt-4.png';
import imageNo from '../images/no/uploader-caresensBt-4.png';
import imageSv from '../images/sv/uploader-caresensBt-4.png';

export const uploaderFinishImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
